import { GroupClassSeriesAnalyticsSources } from "@/constants/analytics/Analytics";
import { GroupClassCarouselVariantValues } from "@/constants/Schedule";
import GroupClassSeriesCarousel from "@/ui/components/explore/GroupClassSeriesCarousel";

// Home-screen recommended groups carousel (promotedGroups variant). Its position on the
// home screen differs by flag: v2 renders it right below "Coming up", v1 lower down.
const RecommendedGroupsCarousel = () => (
  <GroupClassSeriesCarousel
    analyticsSource={GroupClassSeriesAnalyticsSources.RecommendedGroupsList}
    hasPaddingTop={false}
    tabSource="home"
    variant={GroupClassCarouselVariantValues.promotedGroups}
  />
);

export default RecommendedGroupsCarousel;
